import { SupportNoteSource, SupportNoteTag } from '../../stores/types/supportnote.interface';
export const TICKET_TYPES: string[] = [SupportNoteSource.JIRA, SupportNoteSource.ZENDESK];

export const ALL_EVENT_TYPES = [
  SupportNoteTag.CHARGER,
  SupportNoteTag.LOCATION,
  SupportNoteTag.MODEL,
  SupportNoteSource.MAINTENANCE,
  SupportNoteSource.LABEL,
  ...TICKET_TYPES,
];

export const NOTE_TYPES: string[] = [
  SupportNoteTag.CHARGER,
  SupportNoteTag.LOCATION,
  SupportNoteTag.MODEL,
];

export const formatLink = (link: string): string => {
  if (link.startsWith('http://') || link.startsWith('https://')) {
    return link;
  }
  return `https://${link}`;
};
